<app-header></app-header>
<div class="page">
    <div class="container item-1 d-flex justify-content-between align-items-center mt-5 mb-10">
        <div class="description">
            <div class="title">Etkileşimlerinizi
                artırmak ister misiniz?</div>
            <p class="mt-3 mb-5">Sizlere sunacağımız bir çok çeşitli yazılım sistemleri ile müşteri portföyünüzü genişletebilir, etkinliklerinizi ve etkileşimlerinizi arttırabiliriz. </p>
            <a href="https://teams.live.com/l/invite/FEAU62vq7O4S4BJ_gE">Learn More</a>
        </div>
        <img src="../../../assets/img/img-1.png" />
    </div>
    <div class="container item-2 d-flex justify-content-evenly align-items-center mt-5 mb-10">
        <img src="../../../assets/img/img-2.png" />
        <div class="content">
            <div class="title">Analitik düşünme ve <br>yenilikçi tasarım</div>
            <p class="mt-5">Projelerimizde öncelik hedefimiz analitik düşünce tarzı ve yenilikçi tasarımlar ile genel bir kitleye hitap etmektir. Etkileşimlerinizi artırmanın birinci kuralı hedef kitlenin tümüne, doğru kullanıcı deneyimini aktarabilmektir. Bizler müşterileriniz için en uygun tasarımları hayata geçirebilir ve genel kitle memnuniyetini elinizde tutabiliriz.</p>
        </div>
    </div>
    <div class="container item-3 d-flex justify-content-evenly align-items-center mt-5 mb-10 flex-column">
        <h1>Nasıl Çalışıyoruz?</h1>
        <p class="mt-5 mb-5">Profesyonel proje yöneticilerimiz ve profesyonel ekip arkadaşlarımız sayesinde tüm iş ortaklarımıza güven ve başarı sağlamaktayız.</p>
        <div class="steps">
            <div class="step-1">
                <img src="../../../assets/img/search-image.png" />
                <div class="content">
                    <div class="title">Araştırma</div>
                    <p class="mt-2">Markanızı müşteri gözünden inceler, araştırırız. Müşteri portföyünüzü göz önünde bulundurarak ihtiyaçlarınızı belirleriz. Sizlere bir rapor sunarız.</p>
                </div> 
            </div>
            <div class="step-2">
                <img src="../../../assets/img/fast-setup-img.png" />
                <div class="content">
                    <div class="title">Hızlı Kurulum</div>
                    <p class="mt-2">Maksimum 24 saat içerisinde sizlere sunduğumuz sistemlerin kurulumunu gerçekleştirmekteyiz.</p>
                </div> 
            </div>
        </div>
        <div class="steps">
            <div class="step-3">
                <img src="../../../assets/img/billing-img.png" />
                <div class="content">
                    <div class="title">Faturalandırma</div>
                    <p class="mt-2">Ay sonu faturalandırmalarınızda aldığınız servisin bedeli dışında bir fiyat göremezsiniz. Set-up ücreti veya ekstra ücretler talep etmemekteyiz.</p>
                </div> 
            </div>
            <div class="step-4">
                <img src="../../../assets/img/safety-img.png" />
                <div class="content">
                    <div class="title">Güvenlik</div>
                    <p class="mt-2">Müşteri güvenliğiniz bizler için önemlidir. Sizlere sunduğumuz projelerde veya bizlerden talep ettiğiniz projelerde tüm data güvenliğiniz bizlerin sorumluluğundadır.</p>
                </div> 
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
